import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import DiscrepancySearchField from "@tKgpco/Widgets/DiscrepancyHistory/DiscrepancySearchField";
import RMASearchField from "@tKgpco/Widgets/RMAHistory/RMASearchField";
import * as React from "react";

export const poNumberStyles: SearchTextFieldStyles = {};
const styles = poNumberStyles;

const RMASearchFieldPoNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <RMASearchField
            styles={styles}
            parameterField="poNumber"
            label="PO #"
            inputType="text"
            placeholder=""
            testSelector="rma_filterPoNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: RMASearchFieldPoNumber,
    definition: {
        group: "Common",
        displayName: "RMA PO Number",
    },
};

export default widgetModule;
